import { Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import configDefaultForm from "app/common/form/configDefault";
import RequiredLabel from "app/common/form/RequiredLabel";
import { useField, useFormik, useFormikContext } from "formik";
import ErrorIcon from "app/common/form/ErrorIcon";

export default observer(function SelectPagingCheckBoxDetail(props) {
  const { t } = useTranslation();
  const {
    setListOption,
    listSelected,
    api,
    label,
    size = configDefaultForm.size,
    variant = configDefaultForm.variant,
    name,
    hideSelectAll = false,
    searchObject,
    required,
  } = props;
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);

  // phân trang
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const pageSize = 50;

  const loadData = async (pageIndex, reset = false) => {
    const payload = {
      pageIndex,
      pageSize,
      ...searchObject,
    };
    api(payload).then(({ data }) => {
      if (data?.content?.length > 0) {
        let newOptions = reset ? data.content : [...options, ...data.content];

        // Đảm bảo các item đã chọn luôn nằm trong options
        if (listSelected?.length > 0) {
          listSelected.forEach((selected) => {
            if (!newOptions.some((o) => o.id === selected.id)) {
              newOptions.unshift(selected); // thêm vào đầu nếu chưa có
            }
          });
        }

        setOptions(newOptions);

        // check xem còn dữ liệu không
        if (data.content.length < pageSize) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        if (reset) {
          setOptions(listSelected || []);
        }
        setHasMore(false);
      }
    });
  };
  const [field, meta, helpers] = useField(name);
  useEffect(() => {
    if (!open) return;
    loadData(1, true);
    setPage(1);
  }, [open]);
  const getOptionLabel = (option) => {
    if (props.getOptionLabelCustom) return props.getOptionLabelCustom(option);
    return option?.name || option?.description || "";
  };

  const handleClearOptions = () => setListOption([]);

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      setListOption(options);
    } else {
      handleClearOptions();
    }
  };

  const allSelected = options?.length === listSelected?.length;

  const handleToggleSelectAll = () => {
    handleSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (selectedOptions?.length > 0) {
      setListOption(selectedOptions);
    } else {
      setListOption([]);
    }

    if (
      (reason === "select-option" || reason === "remove-option") &&
      !hideSelectAll
    ) {
      if (selectedOptions.find((option) => option.value === "select-all")) {
        handleToggleSelectAll();
      } else {
        setListOption(selectedOptions);
      }
    } else if (reason === "clear") {
      handleClearOptions();
    }
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.value === "select-all" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    if (option.value === "select-all") {
      return (
        <>
          <Checkbox
            color="primary"
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            // style={{ marginRight: 8 }}
            className="mr-8 p-0"
            checked={allSelected}
          />
          {getOptionLabel(option)}
        </>
      );
    }

    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          // style={{ marginRight: 8 }}
          className="mr-8 p-0"
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const filter = createFilterOptions();

  const disLabel = label ? (
    <RequiredLabel label={label} requiredLabel={required} />
  ) : (
    ""
  );

  const isError = meta && meta.touched && meta.error;

  return (
    <>
      <Autocomplete
        options={options}
        multiple
        value={listSelected}
        getOptionLabel={getOptionLabel}
        getOptionSelected={(option, value) => {
          return option?.id === value?.id;
        }}
        name={name}
        onChange={handleChange}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          return hideSelectAll
            ? filtered
            : [
                { description: "Chọn tất cả", value: "select-all" },
                ...filtered,
              ];
        }}
        disableCloseOnSelect
        blurOnSelect="none"
        openOnFocus
        // autoHighlight
        renderOption={optionRenderer}
        noOptionsText={t("general.emptyDataMessageTable")}
        renderInput={(params) => (
          <TextField
            {...params}
            size={size}
            label={disLabel}
            variant={variant}
            InputLabelProps={{
              shrink: true,
            }}
            className={`input-container `}
            error={isError}
            helperText={isError ? meta.error : ""}
          />
        )}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.stopPropagation();
            event.preventDefault();
          }
          return true;
        }}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        ListboxProps={{
          onScroll: (event) => {
            const listboxNode = event.currentTarget;
            if (
              hasMore &&
              listboxNode.scrollTop + listboxNode.clientHeight >=
                listboxNode.scrollHeight - 10
            ) {
              const nextPage = page + 1;
              setPage(nextPage);
              loadData(nextPage);
            }
          },
        }}
      />
    </>
  );
});
